export default function SEOSection() {
  return (
    <section id="seo" className="seo-hidden">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">

        <div className="mb-12">
          <h2 className="font-heading font-bold text-[#1d1d1f] leading-[1.12] tracking-tight mb-8" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)' }}>
            HR-система для виробництва, логістики та масового найму персоналу
          </h2>

          <div className="prose prose-lg max-w-none text-gray-600 space-y-6 leading-relaxed" style={{ fontSize: '15px' }}>

            <p>
              <strong className="text-[#1d1d1f]">HURMA — це ATS і HR-система для виробничих та логістичних компаній</strong>, які наймають багато людей, працюють із кількома майданчиками та хочуть бачити весь шлях кандидата й працівника в одному контурі. Система допомагає <strong className="text-[#1d1d1f]">керувати масовим наймом робітників</strong>, збирати кандидатів з різних джерел, контролювати строки обробки, автоматизувати пребординг і передавати HR-дані в ERP без ручного дублювання.
            </p>

            <h3 className="font-heading font-semibold text-[#1d1d1f] text-xl mt-10 mb-4">
              Чому виробництву потрібна ATS-система
            </h3>

            <p>
              Для виробництва важливо не просто знайти кандидата, а <strong className="text-[#1d1d1f]">швидко довести його до виходу на зміну</strong>. Якщо відгуки приходять з OLX, job-порталів, сайту, форм, рекомендацій і телефонії, рекрутеру складно контролювати весь потік у таблицях. HURMA збирає кандидатів в одну <strong className="text-[#1d1d1f]">ATS для виробництва</strong>, зберігає історію контактів, статуси, коментарі й наступні дії, щоб команда не втрачала людей між каналами.
            </p>

            <h3 className="font-heading font-semibold text-[#1d1d1f] text-xl mt-10 mb-4">
              Автоматизація HR-процесів після найму
            </h3>

            <p>
              HURMA також допомагає <strong className="text-[#1d1d1f]">автоматизувати HR-процеси після найму</strong>: збір даних і документів, пребординг, адаптацію, контроль строків, звітність і аналітику по майданчиках. Керівництво бачить, де вакансії закриваються повільніше, які джерела працюють краще, де росте плинність і скільки часу команда витрачає на ручну роботу.
            </p>

            <h3 className="font-heading font-semibold text-[#1d1d1f] text-xl mt-10 mb-4">
              Інтеграція з ERP та іншими системами
            </h3>

            <p>
              ERP залишається головною системою обліку, а HURMA закриває HR-процеси навколо кандидата й працівника. Дані можна <strong className="text-[#1d1d1f]">передавати в ERP, LMS, телефонію, OLX або BI-системи</strong>, щоб зменшити ручне перенесення, помилки й приховані витрати на доопрацювання процесів.
            </p>

            <h3 className="font-heading font-semibold text-[#1d1d1f] text-xl mt-10 mb-4">
              Для яких компаній підходить HURMA
            </h3>

            <p>
              Система підходить для <strong className="text-[#1d1d1f]">заводів, фабрик, складів, логістичних хабів, агровиробництва, харчового виробництва та виробничо-логістичних мереж</strong>. Особливо там, де є постійний масовий найм, кілька локацій, змінні графіки, високий обсяг кадрових задач і потреба в прозорій HR-аналітиці.
            </p>

            <h4>
              <a href="#faq">Поширені питання про HR-систему HURMA</a>
            </h4>

          </div>
        </div>

      </div>
    </section>
  );
}